import { colorList } from "utils/colors";

// Colors
export const topNavigationColors = {
	light: colorList.TITLE.primary,
	dark: colorList.TITLE.primary,
	
	title: {
		light: colorList.TITLE.primary,
		dark: colorList.TITLE.primary
	},
	subtitle: {
		light: colorList.TEXT.light,
		dark: colorList.TEXT.light
	}
}

// Props
const topNavigationIconProps = {
	fontSize: 24,
	width: 24,
	height: 24,
}

export const topNavigationProps = {
	icon: {
		// color: colorList.BLACK.primary,
		...topNavigationIconProps
	},
	iconLight: {
		color: topNavigationColors.light,
		...topNavigationIconProps
	},
	iconLarge: {
		marginLeft: 4,
		width: 20,
		height: 20,
	}
};
